import { combine, withCallback } from 'react-hooks-combine'
import { ROLES } from 'constants/account.roles'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'

import SignupFormComponent from './component'

const { string, any, custom } = validators

export default combine(
  withFormModel(
    {
      email: spec.flow(
        string.isString,
        string.isEmail,
        string.isNotEmpty,
        any.required
      ),

      firstName: {
        alias: 'First name',
        spec: spec.flow(string.isString),
      },

      lastName: {
        alias: 'Last name',
        spec: spec.flow(string.isString),
      },

      nickName: {
        alias: 'Nickname',
        spec: spec.flow(string.isString),
      },

      password: spec.flow(string.isString, string.isNotEmpty, any.required),

      confirmation: spec.flow(
        string.isString,
        custom.matchProp('password'),
        string.isNotEmpty,
        any.required
      ),
    },
    { id: 'signup-form' }
  ),

  withCallback(
    'onSubmitForm',
    (_state, { onSubmit }) =>
      (entity) =>
        onSubmit({ type: ROLES.USER, entity }),
    []
  )
)(SignupFormComponent)
